module.exports = __webpack_public_path__ + "static/img/dialog_bg.1aea4d9f.png";